import { Injectable } from '@angular/core';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { ICmsPageResource } from '@icms/core/resource/page/icms-page.resource';
import { NCmsBlogCategory } from '../blog/category/cms-blog-category.interface';
import { NCmsBlogPost } from '../blog/post/cms-blog-post.interface';
import { NCmsBlogRoot } from '../blog/root/cms-blog-root.interface';
import { ICmsPageDecorator } from './icms-page.decorator';

@Injectable({
    providedIn: 'root'
})
export class ICmsPageResourceDecorator extends ICmsPageResource<ICmsPageDecorator> {
    /**
     * Loads all blog categories
     */
    loadBlogRoot(verbosity = 2, params: TLoadDependeciesParams): Promise<ICmsPageDecorator[]> | void {
        return this.find({ filter: { pageType: NCmsBlogRoot.typeId }, verbosity }, params);
    }

    /**
     * Loads all blog categories
     */
    loadBlogCategories(verbosity = 2, params: TLoadDependeciesParams): Promise<ICmsPageDecorator[]> | void {
        return this.find({ filter: { pageType: NCmsBlogCategory.typeId }, verbosity }, params);
    }

    /**
     * Loads all blog posts
     */
    loadBlogPosts(verbosity = 2, params: TLoadDependeciesParams): Promise<ICmsPageDecorator[]> | void {
        return this.find({ filter: { pageType: NCmsBlogPost.typeId }, verbosity }, params);
    }
}
